export const CHECKOUT_STATUSES = {
    initial: 'initial',
    loaded: 'loaded',
    pending_review: 'pending_review',
    complete_payment_successfully: 'complete_payment_successfully',
    applied_plan: 'applied_plan',
};
